module.exports = __webpack_public_path__ + "img/p1.56c44e1d.png";